/** Persistent admin JWT (dashboard operator login). */
const KEY = "ia_admin_jwt";

export const ADMIN_JWT_CHANGED = "identity-armour:admin-jwt-changed";

export function getAdminJwt(): string {
  if (typeof localStorage === "undefined") {
    return "";
  }
  return localStorage.getItem(KEY)?.trim() ?? "";
}

export function setAdminJwt(token: string): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(KEY, token.trim());
  window.dispatchEvent(new CustomEvent(ADMIN_JWT_CHANGED));
}

export function clearAdminJwt(): void {
  if (typeof localStorage === "undefined") return;
  localStorage.removeItem(KEY);
  window.dispatchEvent(new CustomEvent(ADMIN_JWT_CHANGED));
}
